import ko from 'knockout';
import { numericActionTypes } from '@bingads-webui-campaign/bulk-operation-base';
import { changeBidActions, nonTextActionsForKeyword } from '../constants';
import { validateBidInput } from '../util';

const defaultAction = {
  action: changeBidActions.IncreaseBid,
  bidValue: null,
  unit: 'percentage',
  useLimitValue: true,
  limitValue: null,
};

export class ChangeKeywordBidActionViewModel {
  constructor({
    i18n,
    accountCurrencyCode,
    keywordBidRange,
    selectedRule,
  }) {
    let nonTextActionInfo = defaultAction;

    this.isChangeByBid = true;
    if (selectedRule && selectedRule.id > 0) {
      nonTextActionInfo = selectedRule.nonTextAction;
    }

    if (selectedRule.action === nonTextActionsForKeyword.RaiseToTopOfPage) {
      nonTextActionInfo.action = changeBidActions.BestBid;
      this.isChangeByBid = false;
    } else if (selectedRule.action === nonTextActionsForKeyword.RaiseToFirstPage) {
      nonTextActionInfo.action = changeBidActions.FirstPageBid;
      this.isChangeByBid = false;
    }

    this.actions = [{
      Value: changeBidActions.IncreaseBid,
      Text: i18n.getString('BulkEdit_Keyword_IncreaseBidOption'),
    },
    {
      Value: changeBidActions.DecreaseBid,
      Text: i18n.getString('BulkEdit_Keyword_DecreaseBidOption'),
    }];
    this.selectedAction = ko.observable(this.isChangeByBid ? nonTextActionInfo.action : '');
    this.bidErrorMessage = ko.observable('');
    this.bidLimitErrorMessage = ko.observable('');
    const actionName = i18n.getString(`RuleAction_Keyword_${selectedRule.action}`);
    this.actionText = ko.observable(actionName);

    this.selectedAction.subscribe(() => {
      this.bidErrorMessage('');
    }, this);

    this.units = [{
      Value: 'percentage',
      Text: '%',
    },
    {
      Value: 'absolute',
      Text: accountCurrencyCode,
    }];
    this.selectedUnit = ko.observable(nonTextActionInfo.unit);

    this.bidValue = ko.observable(nonTextActionInfo.bidValue);
    this.bidValue.subscribe(() => {
      this.bidErrorMessage('');
    }, this);

    this.limitValue = ko.observable(nonTextActionInfo.limitValue);
    this.limitValue.subscribe(() => {
      this.bidLimitErrorMessage('');
    }, this);

    this.useLimitValue = ko.observable(nonTextActionInfo.useLimitValue);

    this.useLimitValue.subscribe(() => {
      this.bidLimitErrorMessage('');
    }, this);

    this.limitBidLabelText = ko.computed(() => {
      if (this.selectedAction() === changeBidActions.DecreaseBid) {
        return i18n.getString('BulKEdit_Keyword_LowerBidLimit');
      }
      return i18n.getString('BulkEdit_Keyword_UpperBidLimit');
    }, this);
    this.accountCurrencyCode = accountCurrencyCode;

    this.validate = () => {
      this.bidErrorMessage('');
      this.bidLimitErrorMessage('');

      const usePercentValidation = this.selectedUnit() === 'percentage';
      if (this.isChangeByBid && !this.bidValue()) {
        if (this.selectedUnit() === 'percentage') {
          this.bidErrorMessage(i18n.getString('BulkEdit_Keyword_MissingPercentageError'));
        } else {
          this.bidErrorMessage(i18n.getString('BulkEdit_Keyword_MissingBidError'));
        }
        return false;
      }

      if (this.isChangeByBid) {
        if (this.bidValue()) {
          this.bidErrorMessage(validateBidInput(
            this.bidValue(),
            i18n, usePercentValidation, keywordBidRange
          ));
          if (this.bidErrorMessage() !== '') {
            return false;
          }
        }
      }

      if (this.useLimitValue()) {
        if (!this.limitValue()) {
          if (this.selectedAction() === changeBidActions.IncreaseBid) {
            this.bidLimitErrorMessage(i18n.getString('BulkEdit_MissingUpperBidLimitError'));
          } else if (this.selectedAction() === changeBidActions.DecreaseBid) {
            this.bidLimitErrorMessage(i18n.getString('BulkEdit_MissingLowerBidLimitError'));
          }
          return false;
        }
        this.bidLimitErrorMessage(validateBidInput(
          this.limitValue(),
          i18n, false, keywordBidRange
        ));

        return this.bidLimitErrorMessage() === '';
      }

      return true;
    };

    this.getUserAction = () => {
      const limitValue = this.useLimitValue() && this.limitValue() ?
        i18n.parseDecimal(this.limitValue()) : null;

      const menuAction = selectedRule.action;
      if (menuAction === 'ChangeBid') {
        const selectedAction = this.selectedAction();
        let bidAmount = this.bidValue() ? i18n.parseDecimal(this.bidValue()) : null;
        if (selectedAction === changeBidActions.DecreaseBid) {
          bidAmount *= -1;
        }
        const actionType = this.selectedUnit() === 'percentage' ?
          numericActionTypes.changeByPercent :
          numericActionTypes.changeByAmount;
        return {
          Actions: [{
            '@odata.type': '#Model.NumericAction',
            Property: 'Bid/Amount',
            ActionType: actionType,
            Value: bidAmount,
            Limit: limitValue,
          }],
        };
      } return {
        Actions: [{
          '@odata.type': '#Model.BidEstimateAction',
          Property: 'Bid/Amount',
          ActionType: menuAction,
          Limit: limitValue,
        }],
      };
    };
  }
}
